import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqospherePrize {
  constructor(api) {
    this.api = api
  }

  getPrize = async (productid, variantid, stock) => {
    return await this.api.get(
      `/iqosphere/prizes/${productid}${variantid ? '/' + variantid : ''}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        params: { ...(stock && { stock: true }) },

        mock: this.api.getMock(!stock ? 'getPrize' : 'getPrizeWithStocks')
      }
    )
  }

  getPrizeBySeoName = async (seoname, stock) => {
    return await this.api.get('/iqosphere/prizes/', {
      params: { ...(seoname && { seoname }), ...(stock && { stock: true }) },
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock(!stock ? 'getPrize' : 'getPrizeWithStocks')
    })
  }

  getPrizes = async (categoryid = '', stock) => {
    return await this.api.get('/iqosphere/prizes', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: {
        ...(categoryid && { categoryid }),
        ...(stock && { stock: true })
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock(!stock ? 'getPrizes' : 'getPrizesWithStocks')
    })
  }

  getPrizesCampaign = async (campaigncode = '', stock) => {
    return await this.api.get('/iqosphere/prizes', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: {
        ...(campaigncode && { campaigncode }),
        ...(stock && { stock: true })
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock(!stock ? 'getPrizes' : 'getPrizesWithStocks')
    })
  }

  getOrderPrize = async (id, line) => {
    return await this.api.get(`/iqosphere/prizes/order/${id}`, {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      params: { t: new Date().getTime(), ...(line && { isPrizeId: true }) },
      mock: this.api.getMock('getOrderPrize')
    })
  }

  confirmAddress = async (data, ignoreAddressValidation = false) => {
    return await this.api.post(
      `/iqosphere/prizes/confirmAddress?b=${ignoreAddressValidation}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('confirmAddress'),
        data
      }
    )
  }

  getSpinWheelStatus = async (campaignCode, missionCode) => {
    return await this.api.get('/iqosphere/spinwheel/status', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getSpinWheelStatus'),
      params: {
        ...(campaignCode && { campaignCode }),
        ...(missionCode && { missionCode })
      },
      useProxy: true,
      withCredentials: true
    })
  }

  spinWheel = async (campaignCode, action, mission, spinType = false) => {
    return await this.api.post('/iqosphere/spinwheel/spin', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('spinWheel'),
      data: {
        campaignCode,
        action,
        ...(mission && { mission }),
        ...(spinType && { spinType: 'free' })
      },
      useProxy: true,
      withCredentials: true
    })
  }

  getCampaignProgress = async campaignCode => {
    return await this.api.get(
      `/iqosphere/campaign/progress?campaign=${campaignCode}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getCampaignProgress'),
        useProxy: true,
        withCredentials: true
      }
    )
  }

  cancel = async prizeId => {
    return await this.api.post('/iqosphere/prize/cancel', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {
        prizeId
      }
    })
  }
}
